/* eslint-disable react/prop-types */
import React, {useEffect, useState} from "react";
// Librairie
import {useHistory} from "react-router-dom";
import {Elements} from "@stripe/react-stripe-js";
// Assets
import "./styles.scss";
import back from "../../../../../../assets/icons/back.svg";
import secure from "../../../../../../assets/img/offerModal/3d-secure.png";
import listCb from "../../../../../../assets/img/offerModal/list-cb.png";
import loading from "../../../../../../assets/gif/loading.gif";
// Composant
import CheckoutForm from "./CheckoutForm";
import {getApiBaseUrl} from "../../../../../../utils/baseUrl";
// Utils
import {loadStripeApiKey} from "../../../../../../utils/getStripeApiKey";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with a fake API key.

const Checkout = ({
                      customerId,
                      percentOff,
                      amountOff,
                      setPromotionCode,
                      promotionCode,
                      checkPromotionCode,
                      dataUser,
                      setResetUserInfos,
                      setStep,
                      setErrorMessage,
                      activationCodeFlag,
                      setShowOfferModal
                  }) => {
    // clientSecret Stripe. Il est passé en options dans le composant <Element> de Stripe pour déclencher les paiements
    // https://stripe.com/docs/payments/payment-element
    const [clientSecret, setClientSecret] = useState("");
    const history = useHistory();

    useEffect(() => {
        setPromotionCode("");
        setClientSecret("");
        // Create PaymentIntent as soon as the page loads
        if (!customerId) {
            return;
        }
        // activationCodeFlag détermine si l'utilisateur à rentrer un code d'activation dans le champ du code promotionnel
        // Code d'activation != code promotionnel
        // Le code promotionnel correspond à un bon de réduction créé sur Stripe
        // Le code d'activation correspond à un code entreprise associant le user à une entreprise en BDD (page code-activation du module login)
        // Le user à la possibilité d'entrer un code d'activation dans le champ code promotionnel. Dans le cas d'un code valide on passela valeur
        // d'activationFlag à true pour signifier que le user n'a pas besoin de payer le service et de ne pas déclencher à nouveau un payementIntent.
        if (!activationCodeFlag) {
            fetch(`${getApiBaseUrl()}/paymentIntentBPCE49/`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    customerId: customerId,
                    promotionCode: window.localStorage.getItem("promotionCode"), // Le code promotionnel à envoyer s'il existe
                }),
            })
                .then((res) => res.json())
                .then((data) => {
                    setClientSecret(data.clientSecret);
                });
        }
    }, [customerId, amountOff, percentOff, activationCodeFlag]); // <-- On veut relancer le code à l'intérieur du useEffect si une de ces valeurs change

    // Style custom pour le formulaire comprenant les inputs des coordonnées bancaires
    const appearance = {
        theme: "none",
        labels: "floating",
        rules: {
            ".Input": {
                border: "1px solid #4F0C28",
                borderRadius: "10vw",
                padding: "5px 15px 5px 35px",
                color: "#4F0C28"
            },
            ".Input:focus": {
                borderColor: "#4F0C28",
            },
            ".Label--resting": {
                color: "#4F0C28",
            },
            ".Label--floating": {
                color: "#4F0C28",
            }
        }
    };
    // Options passé dans le composant <Element>
    const options = {
        clientSecret,
        appearance,
    };

    const handleCheckPromotionCode = (e) => {
        e.preventDefault();
        // Si l'utilisateur à rentrer un code promo
        if (promotionCode) {
            // On vérifie qu'il existe au clique sur valider
            checkPromotionCode();
        }
    };

    const handleSubmitForm = async (e) => {
        await setErrorMessage("");
        // Si l'utilisateur n'a pas de code d'activation et n'a pas coché les case CGU, on affiche un message d'erreur
        if (!activationCodeFlag && !activeRadioBoxCGU || !activeRadioBoxRetraction) {
            e.preventDefault();
            setErrorMessage("Veuillez accepter nos CGU et/ou le renoncement au délai de rétractation ");
        } else if (activationCodeFlag) {
            // Si le user à rentrer un code d'activation cela signifie qu'il n'a pas a payé une offre, on redirige alors vers le chat de demande
            history.push("/conversation");
            setShowOfferModal(false);
        }
    };

    // Calcule des différents montant à afficher pour l'utilisateur (tva, nouveau montant avec réduction appliquée
    const pricePercentOff = (49 - (49 * percentOff) / 100);
    const amountOfPercentOf = ((49 * percentOff) / 100);
    const priceAmountOff = (49 - (amountOff / 100));
    const amountOfTVA = (49 * 0.20);
    const amountOfTVAOnPricePercentOff = pricePercentOff * 0.20;
    const amountOfTVAOnPriceAmountOfff = priceAmountOff * 0.20;

    // Gère les deux cases à cocher obligatoirement pour confirmer le paiement
    const [activeRadioBoxCGU, setActiveRadioBoxCGU] = useState(false);
    const [activeRadioBoxRetraction, setActiveRadioBoxRetraction] = useState(false);

    return (

        <>
            <div className="titleModale">
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    setStep("offer-choices");
                }}>
                    <img src={back}/>
                </a>
                <h1>Finalisez votre paiement</h1>
            </div>

            <ul id="listPayments">
                {!activationCodeFlag &&
                    <li className="active">
                        <h1>
                            <div className="stay-connected-container">
                                <div className="stay-connected active">
                                </div>
                                Par carte bancaire
                            </div>
                            <div><img src={listCb}/></div>
                        </h1>
                        <h2>Payez 49€ TTC en une seule fois</h2>
                        <div className="payout-container">
                            {!clientSecret && <>
                                <img src={loading} alt="Chargement"/>
                                <h1>Chargement en cours, veuillez patienter... Merci !</h1>
                            </>
                            }
                            {clientSecret && !amountOff && !percentOff && (
                                <Elements options={options} stripe={loadStripeApiKey()}>
                                    <CheckoutForm/>
                                </Elements>
                            )}
                            {
                                clientSecret && amountOff && (
                                    <Elements options={options} stripe={loadStripeApiKey()}>
                                        <CheckoutForm/>
                                    </Elements>
                                )
                            }
                            {
                                clientSecret && percentOff && (
                                    <Elements options={options} stripe={loadStripeApiKey()}>
                                        <CheckoutForm/>
                                    </Elements>
                                )
                            }
                        </div>
                    </li>
                }
            </ul>
            <div id="recapPayment">
                <h1>
                    <div>Récapitulatif</div>
                    <div>{!percentOff && !amountOff && !activationCodeFlag && "49"} {percentOff && pricePercentOff.toFixed(2)} {amountOff && priceAmountOff.toFixed(2)} {activationCodeFlag && "0"}€
                        TTC
                    </div>
                </h1>
                <div className="details-recap">
                    <div>
                        {/* eslint-disable-next-line react/prop-types */}
                        <strong>{!dataUser.firstname ? "" : dataUser.firstname + " " + dataUser.name} </strong><br/>
                        {/* eslint-disable-next-line react/prop-types */}
                        {!dataUser.adress ? "" : dataUser.adress}<br/>
                        {/* eslint-disable-next-line react/prop-types */}
                        {!dataUser.cp || dataUser.cp == "0" ? "" : dataUser.cp} {!dataUser.city ? "" : dataUser.city}<br/>
                        <a href="#" className="correction" onClick={() => {
                            setResetUserInfos(true);
                            setStep("offer-49");
                        }}>Corriger</a>
                    </div>
                    <div>
                        Sous-total {!percentOff && !amountOff && !activationCodeFlag && "49"} {percentOff && pricePercentOff.toFixed(2)} {amountOff && priceAmountOff.toFixed(2)} {activationCodeFlag && "0"} €<br/>
                        Dont TVA
                        20% {!percentOff && !amountOff && !activationCodeFlag && amountOfTVA.toFixed(2)} {percentOff && amountOfTVAOnPricePercentOff.toFixed(2)} {amountOff && amountOfTVAOnPriceAmountOfff.toFixed(2)} {activationCodeFlag && "0"} €<br/>
                        {percentOff && `Code promotionnel (-${percentOff}%) -${amountOfPercentOf.toFixed(2)}€`} {amountOff && `Code promotionnel (-${(amountOff / 100)}€)`}<br/>
                    </div>
                </div>
            </div>

            <div className="stay-connected-container">
                <div className={activeRadioBoxCGU ? "stay-connected active" : "stay-connected"}
                     onClick={() => setActiveRadioBoxCGU(!activeRadioBoxCGU)}>
                </div>
                J&apos;accepte les&nbsp;<a href="https://www.prevandcare.com/legals-cgu.php" target="_blank"
                                           rel="noreferrer">conditions générales
                d&apos;utilisation</a>
            </div>

            <div className="stay-connected-container">
                <div className={activeRadioBoxRetraction ? "stay-connected active" : "stay-connected"}
                     onClick={() => setActiveRadioBoxRetraction(!activeRadioBoxRetraction)}>
                </div>
                Afin de bénéficier du service immédiatement après mon règlement, j&apos;accepte de reconcer à mon délai
                de rétractation
                de 14 jours
            </div>
            {!activationCodeFlag &&
                <div className="credit-impot">
                    Vous pouvez
                    récupérer {!percentOff && !amountOff && !activationCodeFlag && "175"} {percentOff && (pricePercentOff / 2).toFixed(2)} {amountOff && (priceAmountOff / 2).toFixed(2)}€
                    après crédit d&apos;impôt*
                </div>
            }
            <div className="text-ci">* Cette prestation donne droit à un crédit d’impôt - Article 199 sexdecies CGI. Le
                crédit
                d’impôt permet de déduire la moitié des frais engagés (charges sociales comprises) de l’impôt sur le
                revenu, dans la
                limite d’un plafond qui varie entre 12 000 et 20 000 euros, soit une réduction d’impôt maximale de 10
                000 euros par
                an. Si le contribuable est faiblement imposé ou non imposable, le contribuable est remboursé de la
                différence.
            </div>
            {!activationCodeFlag &&
                // S'il n'y a pas de code d'activation, on affiche le bouton confirmer le paiement
                <button
                    onClick={handleSubmitForm}
                    className="submit-modal"
                    form={"payment-form"}
                    style={{marginTop: "1.2vh"}}
                >
                    Payer {!percentOff && !amountOff && " 49"} {percentOff && pricePercentOff.toFixed(2)} {amountOff && priceAmountOff.toFixed(2)}€
                    TTC
                </button>
            }
            {activationCodeFlag &&
                // Si le user à entre un code d'activation, alors on affiche un bouton "Contacter un Care Manager"
                <button
                    onClick={handleSubmitForm}
                    className="submit-modal"
                    style={{marginTop: "1.2vh"}}
                >
                    Contacter un Care Manager
                </button>
            }
            <div className="t3d-secure">
                <div><img src={secure}/></div>
                <div>Vous serez peut-être redirigé vers le site de votre établissement bancaire pour valider la
                    transaction.
                </div>
            </div>
        </>
    );
};

export default Checkout;